import React from 'react'
import { FieldValues } from 'react-hook-form'
import {
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import { TurnoverFieldProps } from '../types'

const preventMinusInput = (e: React.KeyboardEvent<HTMLInputElement>) => {
	if (e.key === '-' || e.key === 'e') {
		e.preventDefault()
	}
}

export function TurnoverField<TFieldValues extends FieldValues = FieldValues>({
	control,
	fieldPrefix = '',
}: TurnoverFieldProps<TFieldValues>) {
	const getFieldName = (field: string) =>
		fieldPrefix ? `${fieldPrefix}.${field}` : field

	return (
		<FormField
			control={control}
			name={getFieldName('turnoverRound') as any}
			render={({ field }) => (
				<FormItem>
					<FormLabel className="text-sm sm:text-base">
						เทิร์นโอเวอร์ (จำนวนเท่าของยอด)
					</FormLabel>
					<FormControl>
						<Input
							type="number"
							step="any"
							onKeyDown={preventMinusInput}
							placeholder="กรอกเทิร์นโอเวอร์ (จำนวนเท่าของยอด)"
							{...field}
							value={field.value ?? ''}
							onChange={(e) =>
								field.onChange(e.target.value ? Number(e.target.value) : null)
							}
							className="text-sm sm:text-base"
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
